"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreNodePoxResponseToJSON = exports.CoreNodePoxResponseFromJSONTyped = exports.CoreNodePoxResponseFromJSON = void 0;
function CoreNodePoxResponseFromJSON(json) {
    return CoreNodePoxResponseFromJSONTyped(json, false);
}
exports.CoreNodePoxResponseFromJSON = CoreNodePoxResponseFromJSON;
function CoreNodePoxResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'contract_id': json['contract_id'],
        'first_burnchain_block_height': json['first_burnchain_block_height'],
        'min_amount_ustx': json['min_amount_ustx'],
        'registration_window_length': json['registration_window_length'],
        'rejection_fraction': json['rejection_fraction'],
        'reward_cycle_id': json['reward_cycle_id'],
        'reward_cycle_length': json['reward_cycle_length'],
        'rejection_votes_left_required': json['rejection_votes_left_required'],
        'total_liquid_supply_ustx': json['total_liquid_supply_ustx'],
    };
}
exports.CoreNodePoxResponseFromJSONTyped = CoreNodePoxResponseFromJSONTyped;
function CoreNodePoxResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'contract_id': value.contract_id,
        'first_burnchain_block_height': value.first_burnchain_block_height,
        'min_amount_ustx': value.min_amount_ustx,
        'registration_window_length': value.registration_window_length,
        'rejection_fraction': value.rejection_fraction,
        'reward_cycle_id': value.reward_cycle_id,
        'reward_cycle_length': value.reward_cycle_length,
        'rejection_votes_left_required': value.rejection_votes_left_required,
        'total_liquid_supply_ustx': value.total_liquid_supply_ustx,
    };
}
exports.CoreNodePoxResponseToJSON = CoreNodePoxResponseToJSON;
//# sourceMappingURL=CoreNodePoxResponse.js.map